<template>
  <div class="metrics-overall-summary">
    <div class="metrics-overall-summary__card">
      <div class="metrics-overall-summary__header">
        <span class="metrics-overall-summary__title heading-s">
          {{ $t("metrics.overallSummary") }}
        </span>
        <!-- <eg-icon
          icon="information"
          class="metrics-overall-summary__info-icon"
        /> -->
      </div>
      <div class="metrics-overall-summary__body">
        <p class="metrics-overall-summary__text paragraph-m">{{ summary }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MetricsOverallSummary",

  props: {
    summary: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../shared/metrics_card";

.metrics-overall-summary {
  padding: 0 24px;

  &__card {
    @include metrics-card;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__title {
    color: var(--color-text-neutral-on-white);
  }

  &__info-icon {
    color: var(--color-icon-neutral-secondary, #8a97a4);
    font-size: 14px;
  }

  &__body {
    border-radius: 8px;
    background: var(--color-surface-semantic-informative-light);
    padding: 16px 20px;
  }

  &__text {
    margin: 0;
    color: var(--color-text-neutral-on-white);
    font-weight: var(--typography-font-weight-fw-400, 400);
    text-rendering: geometricprecision;
  }
}
</style>
